import { Info } from 'lucide-react'

/**
 * Shown when the app is loaded outside of a Zoom client (e.g., directly in
 * a browser tab during local dev or as the demo-day rescue path).
 * Same code path otherwise — notes editor + suggestions still work.
 */
export function StandaloneBanner() {
  return (
    <div className="border-b border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      <div className="flex items-start gap-2">
        <Info className="mt-0.5 h-4 w-4 flex-shrink-0" />
        <div>
          <strong>Standalone mode.</strong> The app is running outside a Zoom
          client — meeting context is unavailable, but notes + suggestions still
          work. Open this app from inside a Zoom meeting (Apps panel) for the
          full experience.
        </div>
      </div>
    </div>
  )
}
